import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/food_noimage.png'


const _hoisted_1 = {
  key: 1,
  class: "pantry-food-item-image",
  src: _imports_0
}
const _hoisted_2 = { class: "pantry-food-item-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "pantry-food-item",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          class: "pantry-food-item-image",
          src: _ctx.icon,
          onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
        }, null, 40, ["src"]))
      : (_openBlock(), _createBlock("img", _hoisted_1)),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1)
  ]))
}